import { AsyncPipe } from '@angular/common';
import { Component, Inject, OnInit, TemplateRef, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslocoPipe } from '@jsverse/transloco';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BackLinkComponent } from '@zero/shared/ui-web-components';
import { ListToggleComponent, SwitchComponent } from '@zero/shared/ui-web-design-system';
import { WatchlistFacade } from '@zero/shared/util-global-state';
import { AuthService, DataService } from '@zero/shared/util-web-app-services';
import { environment } from 'environments/environment';
import { LOCAL_STORAGE, StorageService } from 'ngx-webstorage-service';
import { WatchlistComponent } from '../../components/watchlist/watchlist.component';

@Component({
  templateUrl: './watchlist-page.component.html',
  imports: [FormsModule, ListToggleComponent, WatchlistComponent, AsyncPipe, TranslocoPipe, SwitchComponent, BackLinkComponent],
})
export class WatchlistPageComponent implements OnInit {
  public readonly watchlistFacade = inject(WatchlistFacade);
  public showPositions = true;
  public details = true;
  public downloadUrl: string;

  readonly #rootData = inject(DataService);
  readonly #modalService = inject(NgbModal);
  readonly #STORAGE_KEY_DETAILS = 'wlDetails';
  readonly #authService = inject(AuthService);

  public readonly isPotentialCustomer$ = this.#authService.isPotentialCustomer();

  constructor(@Inject(LOCAL_STORAGE) private _storage: StorageService) {}

  ngOnInit(): void {
    this.details = this._storage.get(this.#STORAGE_KEY_DETAILS);
    this.#setDownloadUrl();
  }

  #setDownloadUrl(): void {
    const currentCustomer = this.#rootData.getSelectedCustomerItem();
    if (!currentCustomer && !currentCustomer?.custId) {
      return;
    }
    this.downloadUrl = `${environment.apihost}/api/wl/export.csv?customerId=${currentCustomer.custId}`;
  }

  public toggleDetails(): void {
    this.details = !this.details;
    this._storage.set(this.#STORAGE_KEY_DETAILS, this.details);
  }

  public showSettingsModal(modalContent: TemplateRef<HTMLElement>): void {
    this.#modalService.open(modalContent, { size: 'sm' });
  }
}
